const getArrayIds = (array) => array.map(({ id }) => id)

export default getArrayIds
